// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/LoginPage.css */

.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f4f7f9;
  }
  
  .login-box {
    background: white;
    padding: 2.5rem;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
    text-align: center;
  }
  
  .login-box h2 {
    margin-top: 0;
    margin-bottom: 1.5rem;
    color: #333;
  }
  
  .input-group {
    margin-bottom: 1.5rem;
    text-align: left;
  }
  
  .input-group label {
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: 500;
  }
  
  .input-group input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 1rem;
  }
  
  .login-button {
    width: 100%;
    padding: 0.8rem;
    border: none;
    border-radius: 8px;
    background-color: #007bff;
    color: white;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .login-button:hover {
    background-color: #0056b3;
  }
  
  .error-message {
    color: #dc3545;
    margin-bottom: 1rem;
  }`, "",{"version":3,"sources":["webpack://./src/LoginPage.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB","sourcesContent":["/* frontend/src/LoginPage.css */\n\n.login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #f4f7f9;\n  }\n  \n  .login-box {\n    background: white;\n    padding: 2.5rem;\n    border-radius: 12px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 400px;\n    text-align: center;\n  }\n  \n  .login-box h2 {\n    margin-top: 0;\n    margin-bottom: 1.5rem;\n    color: #333;\n  }\n  \n  .input-group {\n    margin-bottom: 1.5rem;\n    text-align: left;\n  }\n  \n  .input-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    color: #555;\n    font-weight: 500;\n  }\n  \n  .input-group input {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    box-sizing: border-box;\n    font-size: 1rem;\n  }\n  \n  .login-button {\n    width: 100%;\n    padding: 0.8rem;\n    border: none;\n    border-radius: 8px;\n    background-color: #007bff;\n    color: white;\n    font-size: 1.1rem;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .login-button:hover {\n    background-color: #0056b3;\n  }\n  \n  .error-message {\n    color: #dc3545;\n    margin-bottom: 1rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
